import React from "react";

const NotToIncludeRow = props => {
  const handleNotIncludeRowChange = (event, idx) => {
    const updatedNotIncludedDetails = [...props.notIncludedDetails];
    updatedNotIncludedDetails[idx].notIncludeRow = event.target.value;
    props.setNotIncludedDetails(updatedNotIncludedDetails);
  };

  return props.notIncludedDetails.map((val, idx) => {
    let notIncludeRow = `notIncludeRow-${idx}`;
    return (
      <div className="form-row" key={val.index}>
        <div className="col">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              data-id={idx}
              id={notIncludeRow}
              value={val.notIncludeRow} 
              onChange={(e) => handleNotIncludeRowChange(e, idx)}
            />
            <div className="input-group-append">
              {idx === 0 ? (
                <button
                  onClick={() => props.add()}
                  type="button"
                  className="add-btn"
                >
                  <i className="fa fa-plus-circle" aria-hidden="true" />
                </button>
              ) : (
                <button
                  className="delete-btn"
                  onClick={() => props.delete(val)}
                >
                  <i className="fa fa-minus-circle" aria-hidden="true" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  });
};

export default NotToIncludeRow;
